import react from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import SectionModal from "../WidgetsSettings/SectionWidget/SectionModal";
import IntlMessages from "../../../util/IntlMessages";

interface SectionWidgetProps {
   value: any;
   role: any;
   data: any;
}
const SectionWidget: React.FC<SectionWidgetProps> = ({ value, role, data }) => {
   const renderSectionLine = () => {
      if (value?.lineVisibility) {
         if (value?.linePosition === "above") {
            return { borderTop: "2px solid var(--default-sectionTitle)" };
         } else if (value?.linePosition === "under") {
            return { borderBottom: "2px solid var(--default-sectionTitle)" };
         }
      }
   };

   const addFontColorStyle = () => {
      if (value?.fontColor) {
         return { color: value?.fontColor, borderColor: value?.fontColor };
      } else return {};
   };

   return (
      <>
         <Widget
            className={`section-widget ${value?.hideWidgetBorder && "hidden-widget-background"}`}
            bgColor={value.backgroundColourHex}
            role={role}
            extra={
               (role === "OWNER" || role === "MODERATOR") && (
                  //@ts-ignore
                  <SettingsModal
                     widgetName={value.name}
                     widgetId={value.id}
                     icon="setting"
                     deleteIcon="true"
                     children={<SectionModal value={value} data={data} />}
                  />
               )
            }
            children={
               //@ts-ignore
               <div>
                  {value?.titleVisibility && (
                     <h3
                        className="widget-section-title"
                        style={{ ...renderSectionLine(), ...addFontColorStyle() }}
                     >
                        {value?.imageUrl && (
                           <img src={value.imageUrl} className="widget-section-image" />
                        )}
                        <IntlMessages id={value?.titleKey} />
                     </h3>
                  )}
               </div>
            }
         ></Widget>
      </>
   );
};

export default SectionWidget;
